import { gql } from '@generated/gql';

const submitBroadbandRequirementsQuery = gql(`
mutation UpdateBroadbandQuoteRequirements($details: BroadbandUsageRequirementsInput!) {
  updateBroadbandQuoteRequirements(details: $details) {
    ...BundleBasket
  }
}
`);

const selectBroadbandQuoteQuery = gql(`
  mutation SelectBroadbandQuote($input: SelectQuoteInput!) {
    selectQuote(input: $input) {
      ...BundleBasket
    }
  }
`);

const deselectBroadbandQuoteQuery = gql(`
  mutation DeselectBroadbandQuote($input: DeselectQuoteInput!) {
    deselectQuote(input: $input) {
      ...BundleBasket
    }
  }
`);

export {
  submitBroadbandRequirementsQuery,
  selectBroadbandQuoteQuery,
  deselectBroadbandQuoteQuery,
};
